import React, { useContext, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Icon,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import { FiSave } from "react-icons/fi"; // Example icon, you can customize as per your needs

interface SaveDocumentModalProps {
  isOpen: boolean; // Controls modal visibility
  onClose: () => void; // Function to close the modal
  onSaveAsDraft?: () => void; // Function for "Save as Draft" action
  title?: string; // Optional title
  description?: string; // Optional description inside modal
  isLoading?: boolean; // Show loader on buttons
  handleGet?: () => void; // Function to fetch data after save
  data?: any; // Document data to be saved
}

const SaveDocumentModal = ({
  isOpen,
  onClose,
  onSaveAsDraft,
  title = "Save Document",
  description = "Do you want to save this document as a draft?",
  isLoading = false,
  handleGet,
  data,
}: SaveDocumentModalProps) => {
  const [loading, setLoading] = useState(isLoading);
  const { toastNotify } = useContext(AppContext);

  const handleSave = async () => {
    setLoading(true);
    try {
      const response: any = await appRequest("document", "save", data);

      if (response.status !== "success") {
        toastNotify({
          title: "Error",
          message: response?.message || "Failed to save document.",
          type: "error",
        });
      } else {
        toastNotify({
          title: "Success",
          message: response?.message || "Document has been saved successfully.",
          type: "success",
        });

        if (handleGet) {
          handleGet();
        }

        onClose();
      }
    } catch (err: any) {
      toastNotify({
        title: "Error",
        message: err?.message || "An unexpected error occurred.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSaveDraft = () => {
    onSaveAsDraft?.();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        {/* Updated Modal Header with Icon and Centered Title */}
        <ModalHeader>
          {title}
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Text textAlign="center" fontWeight="bold">{description}</Text>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="ghost"
            colorScheme="red.500"
            bgColor="red.500"
            color="white"
            onClick={onClose}
            mr={3}
          >
            Cancel
          </Button>
          <Button
            colorScheme="green"
            bgColor="green"
            onClick={onSaveAsDraft ? handleSaveDraft : handleSave}
            isLoading={loading}
            mr={3}
          >
            {onSaveAsDraft ? "Save as Draft" : "Save Document"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SaveDocumentModal;
